// Доля 0..1 → процент на языке интерфейса.
export const formatPercent = (share: number, locale: string): string =>
  new Intl.NumberFormat(locale, { style: "percent", maximumFractionDigits: 0 }).format(share);
